import Vue from "vue";
import router from "./plugins/router";
import axios from "axios";
import vuetify from "./plugins/vuetify";
import App from "./app.vue";
import store from "./plugins/store.js";
import Qs from "qs";

import jwt_decode from "jwt-decode";
Vue.prototype.$jwtDecode = jwt_decode;

// Components
import "./components";

// Trim needed for windows environments which include a trailing space
let isTestEnv = process.env.NODE_ENV.trim() === "development";

let baseURL = isTestEnv ? "http://localhost:3000" : "https://api.telemonial.com";
const axiosClient = axios.create({
  baseURL,
  paramsSerializer: function (params) {
    return Qs.stringify(params, {
      arrayFormat: "brackets",
      encodeValuesOnly: true,
      skipNulls: true,
    });
  },
});
Vue.prototype.$axios = axiosClient;

Vue.prototype.$unknownImage = require("../public/unknown.png");

const { mediums } = require("./util/enums");
Vue.prototype.$mediums = mediums;

const APIs = {
  TMDB: "tmdb",
  GOOGLEBOOKS: "google_books",
  LISTENNOTES: "listen_notes",
  SPOTIFY: "spotify",
};
Vue.prototype.$APIs = APIs;

new Vue({
  el: "#app",
  data: {
    currentUser: null,
  },
  router,
  vuetify,
  store: store,
  render: (h) => h(App),
});
